import { Flex, Spin, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useCard } from '../../context/CardContext'
import { palette } from '../../theme/palette'
import * as Yup from 'yup'
import { useForm, UseFormRegisterReturn } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { InputMask } from '@react-input/mask'
import { forwardRef, useId, useState } from 'react'
import type { InputHTMLAttributes } from 'react'
import VerifyForm from './VerifyForm'
import axios from '../../utils/axios'
import { OtpConfig } from '../../types/otp-config'
// import { number, expirationDate } from 'card-validator'
interface CustomInputProps extends UseFormRegisterReturn {
    label: string
    placeholder: string
    // name: string;
    errorMsg?: string
    inputMode?: InputHTMLAttributes<HTMLInputElement>['inputMode']
}

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    ({ errorMsg, label, placeholder, ...rest }, forwardedRef) => {
        const id = useId()
        return (
            <Flex vertical gap={'6px'}>
                <label className="card-label" htmlFor={'custom-input' + id}>
                    {label}
                </label>
                <input
                    className="card-input"
                    ref={forwardedRef}
                    placeholder={placeholder}
                    id={'custom-input' + id}
                    {...rest}
                />
                {errorMsg && (
                    <span
                        style={{ fontSize: '12px', color: 'var(--rm-danger)' }}
                        id="standard-weight-helper-text-login"
                    >
                        {errorMsg}
                    </span>
                )}
            </Flex>
        )
    }
)

const CardForm = ({ setStep }: { setStep: any }) => {
    const { saveOtpConfig } = useCard()
    const [loading, setLoading] = useState(false)

    const yupSchema = Yup.object().shape({
        cardNumber: Yup.string()
            // .test('is-card-valid', 'Karta raqami noto\'gri', (value) => {
            //     return number(value || '').isValid
            // })
            .required('Karta raqamini kiritish majburiy')
            .min(19, "Karta raqamini to'liq kiriting"),
        expiry: Yup.string()
            // .test(
            //     'is-date-valid',
            //     'Amal qilish muddati xato',
            //     (value: string) => {
            //         return expirationDate(value || '').isValid
            //     }
            // )
            .required('Amal qilish muddatini kiritish Majburiy')
            .min(5, "Amal qilish muddatini to'liq kiriting"),
    })

    const {
        register,
        handleSubmit,
        // watch,
        formState: { errors },
        setError,
    } = useForm({
        defaultValues: { cardNumber: '', expiry: '' },
        resolver: yupResolver(yupSchema),
    })
    // console.log({
    //     errors,
    //     card: watch('cardNumber'),
    //     expiry: watch('expiry'),
    //     validNum: number(watch('cardNumber')),
    //     validDate: expirationDate(watch('expiry')),
    // })
    const onSubmit = (data: { cardNumber: string; expiry: string }) => {
        // console.log('Submitted Data:', data)
        const number = data.cardNumber.replaceAll(' ', '')
        setLoading(true)
        // setStep(VerifyForm.name)
        axios
            .post('/card/add', { number, expiry: data.expiry.replace('/', '') })
            .then((res) => {
                const options: OtpConfig = {
                    id: res.headers['otp-id'],
                    source: res.headers['otp-source'],
                }
                saveOtpConfig(options)
            })
            .then(() => {
                setStep(VerifyForm.name)
            })
            .catch((err) => {
                setError('cardNumber', { message: err?.body?.message || 'Kartani qo\'shib bo\'lmadi' })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const tributeLink = process.env.REACT_APP_TRIBUTE_LINK

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {tributeLink && (
                <a
                    href={tributeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tribute-link-block"
                >
                    <span className="tribute-link-title">Tribute</span>
                    <span className="tribute-link-desc">
                        Chet eldan USD va boshqa valyutalarda to'lov qilish uchun
                    </span>
                    <span className="tribute-link-arrow">→</span>
                </a>
            )}
            <Typography.Title level={5} className="section-title">
                Karta ma'lumotlari
            </Typography.Title>
            <Flex gap={'12px'} vertical>
                <InputMask
                    mask="____ ____ ____ ____"
                    component={CustomInput}
                    errorMsg={errors.cardNumber?.message}
                    placeholder="1234 5678 9012 3456"
                    label="Karta raqami"
                    replacement={{ _: /\d/ }}
                    name="cardNumber"
                    inputMode="numeric"
                    {...register('cardNumber')}
                    disabled={loading}
                />
                <InputMask
                    mask="__/__"
                    component={CustomInput}
                    errorMsg={errors.expiry?.message}
                    placeholder="00/00"
                    label="Amal qilish muddati"
                    replacement={{ _: /\d/ }}
                    name="expiry"
                    inputMode="numeric"
                    {...register('expiry')}
                    disabled={loading}
                />
                <button 
                    className="submit-btn" 
                    type="submit"
                    disabled={loading}
                    style={{
                        opacity: loading ? 0.7 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                    }}
                >
                    {loading && (
                        <Spin
                            size="small"
                            indicator={<LoadingOutlined spin style={{ fontSize: 16, color: palette.onAccent }} />}
                        />
                    )}
                    Qo'shish
                </button>
            </Flex>

            <p className="payme-note">
                Sizning kartangiz ma'lumotlari ushbu servisda emas, balki
                bevosita Click serverida saqlanadi
            </p>
        </form>
    )
}

export default CardForm
